// Filter for course category
jQuery(document).ready(function ($){
    $(".cat").each(function () {
        $(this).on("click", function () {
          $('.cat').removeClass('active');
          $(this).addClass('active');
          $('.course').removeClass('active');
          $('.course[data-id*=' + $(this).attr('data-id') + ']').addClass('active');
          if ($(this).data('id') == 'all-items') {
            $('.course').addClass('active');
          }
        });
    });
});